export default "__VITE_ASSET__WB3IeD9i__"